import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Typography,
  message,
} from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const { Text } = Typography;
const { Option } = Select;

const EditRegionalManager = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { regionalManagerId } = useParams();
  const [regionList, setRegionList] = useState([]);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  useEffect(() => {
    if (!token) {
      message.error("Session expired, please login again");
      return;
    }
    fetchRegions();
    fetchManagerDetails();
  }, [token]);

  const fetchRegions = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASEURL}/region`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRegionList(res.data || []);
    } catch (err) {
      message.error("Failed to fetch regions");
    }
  };

  const fetchManagerDetails = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASEURL}/regional-manager/${regionalManagerId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = res.data;
      const regionsVal = data.regions
        ? data.regions.map((r) => r._id || r)
        : (data.region ? [data.region._id || data.region] : []);

      form.setFieldsValue({
        employeeName: data.employeeName,
        employeeCode: data.employeeCode,
        contactNumber: data.contactNumber,
        email: data.email,
        regions: regionsVal,
      });
    } catch (err) {
      message.error("Failed to load regional manager details");
    }
  };

  const handleUpdate = async (values) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASEURL}/regional-manager/${regionalManagerId}`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      message.success("Regional manager updated successfully");
      navigate("/regional-managers");
    } catch (err) {
      message.error("Failed to update regional manager");
    }
  };

  return (
    <div className="p-4">
      <Card title="Edit Regional Manager">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleUpdate}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="Regional Manager Name"
                name="employeeName"
                rules={[{ message: "Please enter name" }]}
              >
                <Input placeholder="Ex: John Doe" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Employee Code"
                name="employeeCode"
                rules={[{ message: "Please enter employee code" }]}
              >
                <Input placeholder="Ex: EMP101" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Phone"
                name="contactNumber"
                rules={[
                  { message: "Please enter phone number" },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Phone must be 10 digits",
                  },
                ]}
              >
                <Input placeholder="Ex: 0987654321" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { message: "Please enter email" },
                  {
                    type: "email",
                    message: "Enter a valid email",
                  },
                ]}
              >
                <Input placeholder="Ex: john@email.com" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Regions"
                name="regions"
                rules={[{ required: true, message: "Please select at least one Region." }]}
              >
                <Select
                  mode="multiple"
                  showSearch
                  placeholder="Select Regions"
                  optionFilterProp="children"
                >
                  {regionList.map((r) => (
                    <Option key={r._id} value={r._id}>
                      {r.regionName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row justify="start">
            <Col>
              <Button
                type="primary"
                icon={<EditOutlined />}
                htmlType="submit"
                style={{ backgroundColor: PRIMARY_RED, borderColor: PRIMARY_RED }}
              >
                Edit Regional Manager
              </Button>
              <Button
                type="link"
                icon={<ArrowLeftOutlined />}
                style={{ color: PRIMARY_RED }}
                onClick={() => navigate("/regional-managers")}
              >
                Back
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default EditRegionalManager;
